import Config from 'react-native-config';
import { Alert } from '../components/Alert';
import { isEmailNotConfirmedError, SIGNUP_ERROR_COPY, } from '@shared/signup/signupErrors';
import { maintenanceStore } from '../maintenance/maintenanceStore';
import { isMaintenanceError, maintenanceFromError, } from '../maintenance/maintenanceState';
export const EMAIL_NOT_CONFIRMED_TITLE = 'Confirm your email';
export const RESEND_CONFIRMATION_LABEL = 'Resend confirmation email';
const INVALID_LOGIN_TITLE = "Couldn't sign in";
const INVALID_LOGIN_MESSAGE = 'We could not sign you in with those details. Check your email and password, then try again.';
function isInvalidLoginError(error) {
    if (!error ||
        typeof error !== 'object' ||
        error.status !== 422) {
        return false;
    }
    const err = error;
    const errors = err.data?.errors;
    if (!errors || typeof errors !== 'object') {
        return false;
    }
    return (errors.emailOrPassword === 'invalidCredentials' ||
        errors.password === 'incorrectPassword');
}
export const reportServerError = (error, options = {}) => {
    // Maintenance 503: the full-screen view (native) or banner (web) explains it; no alert.
    if (isMaintenanceError(error)) {
        maintenanceStore.report(maintenanceFromError(error));
        return;
    }
    // Log the entire error object for detailed inspection
    console.log('--- reportServerError --- BEGIN ERROR ---', JSON.stringify(error, null, 2));
    console.log('Error object direct:', error);
    console.log('Error status property:', error?.status);
    console.log('Error data property:', JSON.stringify(error?.data, null, 2));
    console.log('Error message property:', error?.message);
    console.log('BACKEND_BASE_URL:', Config.BACKEND_BASE_URL);
    console.log('--- reportServerError --- END ERROR ---');
    if (isEmailNotConfirmedError(error)) {
        Alert(EMAIL_NOT_CONFIRMED_TITLE, SIGNUP_ERROR_COPY.emailNotConfirmed, options.onResendConfirmation
            ? [
                { text: 'Not now', style: 'cancel' },
                {
                    text: RESEND_CONFIRMATION_LABEL,
                    style: 'default',
                    onPress: options.onResendConfirmation,
                },
            ]
            : [{ text: 'OK' }]);
    }
    else if (isInvalidLoginError(error)) {
        Alert(INVALID_LOGIN_TITLE, INVALID_LOGIN_MESSAGE, [{ text: 'OK' }]);
    }
    else if (error && error.status === 500) {
        // Note: "This email address is already in use." for a 500 status is unusual.
        // Typically, a 500 is a generic internal server error.
        // An "email in use" error is often a 409 (Conflict) or 422 (Unprocessable Entity).
        Alert('Server Error', 'An issue occurred on the server. Please try again later.', [{ text: 'OK' }]);
    }
    else if (error && error.status === 'FETCH_ERROR') {
        // Handle client-side network errors
        const nestedErrorMessage = typeof error.error === 'string'
            ? error.error
            : 'Please check your network connection and try again.';
        Alert('Network Error', `Could not connect to the server. ${nestedErrorMessage}`, [{ text: 'OK' }]);
    }
    else {
        // Fallback for other unexpected errors
        const messageDetail = error?.message ||
            (typeof error?.error === 'string' ? error.error : 'No specific message.');
        const displayMessage = `Status: ${error?.status || 'N/A'}\nMessage: ${messageDetail}\nDetails: ${JSON.stringify(error?.data || error).substring(0, 200)}...`;
        Alert('Unexpected server error', displayMessage, [{ text: 'OK' }]); // Provide a default OK button
    }
};
